import Axios from "axios";
import store from "@/store";
import { eventBus } from "@/main";
var BaseUrl = "https://cphl.esite-lab.com/api.php";

Axios.interceptors.request.use(
    config => {
        const token = store.state.token;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

export const FormHeader = {
    headers: {
        "Content-Type": "application/x-www-form-urlencoded",
    },
};
export function __HTTP($endPoint, $params, $headers, callBack) {
    Axios.post(BaseUrl + $endPoint, $params, $headers).then(res => {
        if (res.status != 200) {
            alert("حدث خلل في العملية");
        } else {
            try {
                if (res.data.logout) {
                    store.dispatch("setLogout");
                    eventBus.$emit("logout");
                }
            } catch (e) {
                console.log(e);
            }
            callBack(res.data);
        }
    });
}
export function __HAS_PERM(permid, uid, hasPerm) {
    __HTTP(
        "?do=checkperms",
        {
            pid: permid,
            uid: uid,
        },
        FormHeader,
        res => {
            //console.log(res);
            if (res.auth == true) {
                hasPerm(true);
            } else {
                // alert("لا تمتلك صلاحية");
                // return false;
                return true;
            }
        }
    );
}
export function __GET_AS_LIST($type, $extra = {}, callBack) {
    __HTTP("?do=getlist", { type: $type, extra: $extra }, FormHeader, res => {
        callBack(res);
    });
}
